/** ADDRESS EXTRACTION **/

/**
 * Address extraction for AU
 * @param data
 * @returns {{address1: *, address2: *, postcode: *, street_number: *, street_type: *,
 *  city: *, state: *, unit_number: *, street_name: *, suburb: *}}
 */
function extractAddAU(data) {
  const {
    address1,
    address2,
    postcode,
    street_number,
    street_type,
    city,
    state,
    unit_number,
    street_name,
    suburb,
    building_name
  } = data;
  return {
    address1,
    address2,
    postcode,
    street_number,
    street_type,
    city,
    state,
    unit_number,
    street_name,
    suburb,
    building_name
  };
}

/**
 * Address extraction for SG
 * @param data
 * @returns {{address1: *, address2: *, building_name: *, block_number: *,
 *  postcode: *, street_number: *, street_type: *, city: *, state: *, unit_number: *, street_name: *, suburb: *}}
 */
function extractAddSG(data) {
  const {
    address1,
    address2,
    building_name,
    block_number,
    postcode,
    street_number,
    street_type,
    city,
    state,
    unit_number,
    street_name,
    suburb,
    floor_number
  } = data;
  return {
    address1,
    address2,
    building_name,
    block_number,
    street_number,
    street_type,
    city,
    state,
    unit_number,
    floor_number,
    street_name,
    suburb,
    postcode
  };
}

/**
 * Address extraction for HK
 * @param data
 * @returns {{address1: *, address2: *, unit_number: *, street_name: *, state: *, building_name: *,
 *  city: *, floor_number: *, building_number: *, district: *}}
 */
function extractAddHK(data) {
  const {
    address1,
    address2,
    unit_number,
    street_name,
    state,
    building_name,
    city,
    floor_number,
    building_number,
    district
  } = data;
  return {
    address1,
    address2,
    unit_number,
    street_name,
    state,
    building_name,
    city,
    floor_number,
    building_number,
    district
  };
}

/**
 * Address extraction for MY
 * @param data
 * @returns {{address1: *, postcode: *, city: *, unit_number: *}}
 */
function extractAddMY(data) {
  const { address1, postcode, city, unit_number } = data;
  return {
    address1,
    postcode,
    city,
    unit_number
  };
}

/**
 * Address extraction for US
 * @param data
 * @returns {{address1: *, address2: *, unit_number: *, street_name: *, state: *, building_name: *,
 *  city: *, floor_number: *, building_number: *, district: *}}
 */
function extractAddUS(data) {
  const {
    address1,
    address2,
    unit_number,
    street_name,
    state,
    building_name,
    city,
    floor_number,
    building_number,
    district
  } = data;
  return {
    address1,
    address2,
    unit_number,
    street_name,
    state,
    building_name,
    city,
    floor_number,
    building_number,
    district
  };
}
/**
 * Address extraction for DE
 * @param data
 * @returns {{unit_number: *, building_number: *, street_name: *, city: *, postcode: *}}
 */
function extractAddDE(data) {
  const { unit_number, building_name, street_name, city, postcode } = data;
  return {
    unit_number,
    building_name,
    street_name,
    city,
    postcode
  };
}

/**
 * Address extraction for IT
 * @param data
 * @returns {{unit_number: *, building_number: *, street_name: *, city: *,province:*, postcode: *}}
 */
function extractAddIT(data) {
  const { unit_number, building_name, street_name, city, province, postcode } = data;
  return {
    unit_number,
    building_name,
    street_name,
    city,
    province,
    postcode
  };
}

/**
 * Address extraction for NL
 * @param data
 * @returns {{unit_number: *, building_number: *, street_name: *, city: *,province:*, postcode: *}}
 */
function extractAddNL(data) {
  const { unit_number, building_name, street_name, city, postcode } = data;
  return {
    unit_number,
    building_name,
    street_name,
    city,
    postcode
  };
}

/**
 * Address extraction default
 * @param data
 * @returns {{address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}
 */
function extractAddDefault(data) {
  const {
    address1,
    address2,
    floor_number,
    postcode,
    post_code,
    street_number,
    unit_number,
    street_name,
    country_name,
    country,
    pin_code
  } = data;
  return {
    address1,
    address2,
    floor_number,
    street_number,
    street_name,
    country_name,
    country,
    postcode,
    post_code,
    unit_number,
    pin_code
  };
}

/** INDIVIDUAL PROFILE EXTRACTION **/

/**
 * Individual profile extraction for AU
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, postcode: *, street_number: *, street_type: *, city: *, state: *,
 *  unit_number: *, street_name: *, suburb: *}}}
 */
function individualAU(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    virtual_account_number,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      virtual_account_number,
      is_pep,
      intended_use_of_account
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddAU(data)
  };
}

/**
 * Individual profile extraction for SG
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *, net_worth: *, is_dual_citizen: *,
 *  industry_type: *}, contact: {mobile_number: *, email: *}, address: {address1: *, address2: *,
 *  building_name: *, block_number: *, postcode: *, street_number: *, street_type: *, city: *,
 *  state: *, unit_number: *, street_name: *, suburb: *}}}
 */
function individualSG(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    net_worth,
    is_dual_citizen,
    industry_type,
    mobile_number,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account,
      net_worth,
      is_dual_citizen,
      industry_type
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddSG(data)
  };
}

/**
 * Individual profile extraction for HK
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *,
 *  nationality: *, employment_status: *, is_pep: *, intended_use_of_account: *},
 *  contact: {mobile_number: *, email: *}, address: {address1: *, address2: *, unit_number: *,
 *  street_name: *, state: *, building_name: *, city: *, floor_number: *, building_number: *, district: *}}}
 */
function individualHK(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    email
  } = data;

  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddHK(data)
  };
}

/**
 * Individual profile extraction for MY
 * @param data
 * @returns {{personal: {date_of_birth: *, source_of_funds: *, nationality: *, employment_status: *,
 *  is_pep: *, intended_use_of_account: *, industry_type: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, postcode: *, city: *, unit_number: *}}}
 */
function individualMY(data) {
  const {
    date_of_birth,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    industry_type,
    mobile_number,
    occupation,
    email,
    country_of_residence
  } = data;
  return {
    personal: {
      date_of_birth,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account,
      industry_type,
      occupation,
      country_of_residence
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddMY(data)
  };
}

/**
 * Individual profile extraction for US
 * @param data
 * @returns {{personal: {date_of_birth: *, employment_status: *, industry_type: *, source_of_funds: *,
 *  identity_number: *}, contact: {mobile_number: *, email: *}, address: {address1: *, address2: *,
 *  unit_number: *, street_name: *, state: *, building_name: *, city: *, floor_number: *, building_number: *, district: *}}}
 */
function individualUS(data) {
  const {
    date_of_birth,
    employment_status,
    industry_type,
    source_of_funds,
    identity_number,
    mobile_number,
    virtual_account_number,
    email,
    nationality,
    country_of_residence
  } = data;
  return {
    personal: {
      date_of_birth,
      employment_status,
      industry_type,
      source_of_funds,
      identity_number,
      virtual_account_number,
      nationality,
      country_of_residence
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddUS(data)
  };
}
/**
 * Individual profile extraction default
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function individualDE(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddDE(data)
  };
}
/**
 * Individual profile extraction default
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function individualDefault(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    name_as_per_aadhar,
    pan_card,
    aadhar_card,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account,
      name_as_per_aadhar,
      aadhar_card,
      pan_card
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddDefault(data)
  };
}
/**
 * Individual profile extraction default
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function individualIT(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddIT(data)
  };
}
/**
 * Individual profile extraction default
 * @param data
 * @returns {{personal: {date_of_birth: *, country_of_residence: *, source_of_funds: *, nationality: *,
 *  employment_status: *, is_pep: *, intended_use_of_account: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function individualNL(data) {
  const {
    date_of_birth,
    country_of_residence,
    source_of_funds,
    nationality,
    employment_status,
    is_pep,
    intended_use_of_account,
    mobile_number,
    email
  } = data;
  return {
    personal: {
      date_of_birth,
      country_of_residence,
      source_of_funds,
      nationality,
      employment_status,
      is_pep,
      intended_use_of_account
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddNL(data)
  };
}
/**
 * logic to return the initializer based on the user's country code
 * @param country
 * @returns {function} the initializer w.r.t to the country code
 */
export function individualProfileInitializer(country) {
  switch (country) {
    case 'AU':
      return individualAU;
    case 'SG':
      return individualSG;
    case 'HK':
      return individualHK;
    case 'MY':
      return individualMY;
    case 'US':
      return individualUS;
    case 'DE':
      return individualDE;
    case 'IT':
      return individualIT;
    case 'NL':
      return individualNL;
    default:
      return individualDefault;
  }
}

/** CORPORATE PROFILE EXTRACTION **/

/**
 * Corporate profile extraction for AU
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, postcode: *, street_number: *, street_type: *, city: *, state: *,
 *  unit_number: *, street_name: *, suburb: *}}}
 */
function corporateAU(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number,
    virtual_account_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account,
      virtual_account_number
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddAU(data)
  };
}

/**
 * Corporate profile extraction for SG
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *, trade_name: *,
 *  company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, building_name: *, block_number: *, postcode: *, street_number: *,
 *  street_type: *, city: *, state: *, unit_number: *, street_name: *, suburb: *}}}
 */
function corporateSG(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddSG(data)
  };
}

/**
 * Corporate profile extraction for HK
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *,
 *  annual_turnover: *, business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *,
 *  intended_use_of_account: *}, contact: {phone_country_code: *, phone_number: *, mobile_country_code: *,
 *  mobile_number: *}, address: {address1: *, address2: *, unit_number: *, street_name: *, state: *,
 *  building_name: *, city: *, floor_number: *, building_number: *, district: *}}}
 */
function corporateHK(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddHK(data)
  };
}

/**
 * Corporate profile extraction for MY
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, postcode: *, city: *, unit_number: *}}}
 */
function corporateMY(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddMY(data)
  };
}

/**
 * Corporate profile extraction for US
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, trade_name: *, company_entity: *,
 *  website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *, business_registration_type: *,
 *  other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *}, contact: {phone_country_code: *,
 *  phone_number: *, mobile_country_code: *, mobile_number: *}, address: {address1: *, address2: *, floor_number: *,
 *  postcode: *, street_number: *, unit_number: *}}}
 */
function corporateUS(data) {
  const {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      is_trading_on_behalf,
      intended_use_of_account,
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    } = data,
    info = {
      personal: {
        registered_business_name,
        country_of_business,
        trade_name,
        company_entity,
        website_url,
        industry_type,
        expected_monthly_volume,
        annual_turnover,
        business_registration_type,
        other_countries_of_business: data.other_countries_of_business_name
          ? data.other_countries_of_business_name.join(', ')
          : 'No other countries of business',
        is_trading_on_behalf,
        intended_use_of_account
      },
      contact: {
        phone_country_code,
        phone_number,
        mobile_country_code,
        mobile_number
      },
      address: extractAddDefault(data)
    };
  info.personal[company_entity === 'Sole Proprietorship' ? 'SSN' : 'EIN'] =
    business_registration_number;
  return info;
}

/**
 * Corporate profile extraction DE
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function corporateDE(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddDE(data)
  };
}

/**
 * Corporate profile extraction IT
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function corporateIT(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddIT(data)
  };
}

/**
 * Corporate profile extraction default
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function corporateNL(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddNL(data)
  };
}

/**
 * Corporate profile extraction default
 * @param data
 * @returns {{personal: {registered_business_name: *, country_of_business: *, business_registration_number: *,
 *  trade_name: *, company_entity: *, website_url: *, industry_type: *, expected_monthly_volume: *, annual_turnover: *,
 *  business_registration_type: *, other_countries_of_business: *, is_trading_on_behalf: *, intended_use_of_account: *},
 *  contact: {phone_country_code: *, phone_number: *, mobile_country_code: *, mobile_number: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function corporateDefault(data) {
  const {
    registered_business_name,
    country_of_business,
    business_registration_number,
    trade_name,
    company_entity,
    website_url,
    industry_type,
    expected_monthly_volume,
    annual_turnover,
    business_registration_type,
    is_trading_on_behalf,
    intended_use_of_account,
    phone_country_code,
    phone_number,
    mobile_country_code,
    mobile_number
  } = data;
  return {
    personal: {
      registered_business_name,
      country_of_business,
      business_registration_number,
      trade_name,
      company_entity,
      website_url,
      industry_type,
      expected_monthly_volume,
      annual_turnover,
      business_registration_type,
      other_countries_of_business: data.other_countries_of_business_name
        ? data.other_countries_of_business_name.join(', ')
        : 'No other countries of business',
      is_trading_on_behalf,
      intended_use_of_account
    },
    contact: {
      phone_country_code,
      phone_number,
      mobile_country_code,
      mobile_number
    },
    address: extractAddDefault(data)
  };
}

export function corporateProfileInitializer(country) {
  switch (country) {
    case 'AU':
      return corporateAU;
    case 'SG':
      return corporateSG;
    case 'HK':
      return corporateHK;
    case 'MY':
      return corporateMY;
    case 'US':
      return corporateUS;
    case 'DE':
      return corporateDE;
    case 'IT':
      return corporateIT;
    case 'NL':
      return corporateNL;
    default:
      return corporateDefault;
  }
}

/** REPRESENTATIVE PROFILE EXTRACTION **/

/**
 * Representative profile extraction for AU
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, country_of_residence: *, nationality: *,
 *  authorities: *}, contact: {mobile_number: *, email: *}, address: {address1: *, address2: *, postcode: *,
 *  street_number: *, street_type: *, city: *, state: *, unit_number: *, street_name: *, suburb: *}}}
 */
function representativeProfileAU(data) {
  const {
    date_of_birth,
    country_of_residence,
    nationality,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      country_of_residence,
      nationality,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddAU(data)
  };
}

/**
 * Representative profile extraction for SG
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, country_of_residence: *, nationality: *,
 *  authorities: *}, contact: {mobile_number: *, email: *}, address: {address1: *, address2: *, building_name: *,
 *  block_number: *, postcode: *, street_number: *, street_type: *, city: *, state: *, unit_number: *, street_name: *,
 *  suburb: *}}}
 */
function representativeProfileSG(data) {
  const {
    date_of_birth,
    country_of_residence,
    nationality,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      country_of_residence,
      nationality,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddSG(data)
  };
}

/**
 * Representative profile extraction for HK
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, country_of_residence: *, nationality: *,
 *  authorities: *}, contact: {mobile_number: *, email: *}, address: {address1: *, address2: *, unit_number: *,
 *  street_name: *, state: *, building_name: *, city: *, floor_number: *, building_number: *, district: *}}}
 */
function representativeProfileHK(data) {
  const {
    date_of_birth,
    country_of_residence,
    nationality,
    mobile_number,
    first_name,
    last_name,
    email
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      country_of_residence,
      nationality,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddHK(data)
  };
}
/**
 * Representative profile extraction DE
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, employment_status: *, industry_type: *,
 *  source_of_funds: *, identity_number: *, authorities: *}, contact: {mobile_number: *, email: *},
 * address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function representativeProfileDE(data) {
  const {
    date_of_birth,
    employment_status,
    industry_type,
    source_of_funds,
    identity_number,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      employment_status,
      industry_type,
      source_of_funds,
      identity_number,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddDE(data)
  };
}
/**
 * Representative profile extraction IT
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, employment_status: *, industry_type: *,
 *  source_of_funds: *, identity_number: *, authorities: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function representativeProfileIT(data) {
  const {
    date_of_birth,
    employment_status,
    industry_type,
    source_of_funds,
    identity_number,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      employment_status,
      industry_type,
      source_of_funds,
      identity_number,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddIT(data)
  };
}
/**
 * Representative profile extraction NL
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, employment_status: *, industry_type: *,
 *  source_of_funds: *, identity_number: *, authorities: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function representativeProfileNL(data) {
  const {
    date_of_birth,
    employment_status,
    industry_type,
    source_of_funds,
    identity_number,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      employment_status,
      industry_type,
      source_of_funds,
      identity_number,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddNL(data)
  };
}
/**
 * Representative profile extraction default
 * @param data
 * @returns {{personal: {first_name: *, last_name: *, date_of_birth: *, employment_status: *, industry_type: *,
 *  source_of_funds: *, identity_number: *, authorities: *}, contact: {mobile_number: *, email: *},
 *  address: {address1: *, address2: *, floor_number: *, postcode: *, street_number: *, unit_number: *}}}
 */
function representativeDefault(data) {
  const {
    date_of_birth,
    employment_status,
    industry_type,
    source_of_funds,
    identity_number,
    mobile_number,
    email,
    first_name,
    last_name
  } = data;
  return {
    personal: {
      first_name,
      last_name,
      date_of_birth,
      employment_status,
      industry_type,
      source_of_funds,
      identity_number,
      authorities: data.authorityList
    },
    contact: {
      mobile_number,
      email
    },
    address: extractAddDefault(data)
  };
}

export function representativeProfileInitializer(country) {
  switch (country) {
    case 'AU':
      return representativeProfileAU;
    case 'SG':
      return representativeProfileSG;
    case 'HK':
      return representativeProfileHK;
    case 'DE':
      return representativeProfileDE;
    case 'IT':
      return representativeProfileIT;
    case 'NL':
      return representativeProfileNL;
    default:
      return representativeDefault;
  }
}
